/*
 * Atlas Persian Rug Cleaning — mobile background positioning correction.
 * Keeps the current Canvify composition, but biases the hero media to the right
 * so the hand/arm lands at the right edge as requested in the correction sheet.
 */
(() => {
  const MOBILE_MAX = 749;
  let applying = false;
  let observer = null;

  function pickLargestMedia(root) {
    let best = null, bestArea = 0;
    root.querySelectorAll('video, img').forEach((el) => {
      const r = el.getBoundingClientRect();
      const area = Math.max(0,r.width) * Math.max(0,r.height);
      if (area > bestArea) { best = el; bestArea = area; }
    });
    return best;
  }

  function applyFix() {
    if (applying || window.innerWidth > MOBILE_MAX) return;
    const root = document.querySelector('#root');
    if (!root) return;
    const media = pickLargestMedia(root);
    if (!media) return;

    applying = true;
    try {
      media.style.setProperty('object-fit', 'cover', 'important');
      media.style.setProperty('object-position', '100% 50%', 'important');
      // Use the individual translate property so we do not overwrite Canvify's transform.
      media.style.setProperty('translate', '6% 0', 'important');
    } finally {
      applying = false;
    }
  }

  function init() {
    [0,100,250,500,900,1500,2500].forEach(d => setTimeout(() => requestAnimationFrame(applyFix), d));
    const root = document.querySelector('#root');
    if (root && !observer) {
      observer = new MutationObserver(() => !applying && requestAnimationFrame(applyFix));
      observer.observe(root,{childList:true,subtree:true,attributes:false});
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  window.addEventListener('load',init,{once:true});
  window.addEventListener('resize',init);
})();
